import { Link } from "react-router-dom";

const Logo = ({ dark = false, monogramOnly = false }) => (
  <Link to="/" className="inline-flex items-center group" data-testid="logo-link" aria-label="Per Lei Bridal">
    <img
      src={monogramOnly ? (dark ? "/logo-monogram-white.png" : "/logo-monogram.png") : (dark ? "/logo-full-white.png" : "/logo-full.png")}
      alt="Per Lei Bridal"
      className={`w-auto transition-all duration-700 group-hover:opacity-70 ${monogramOnly ? "h-12" : "h-12 lg:h-16"}`}
      draggable="false"
    />
  </Link>
);

export default Logo;
